module.exports = __webpack_public_path__ + "media/clip_website_2.872031cc.mp4";